import { graphql } from '../../gql';

export const ENTITY_V2_QUERY = graphql(`
  query GetEntityDataV2($req: EntityV2Req) {
    entityV2(req: $req) {
      entity {
        name
        description
        founded
        headquarters
      }
      competitors {
        closeness
        id
        shortName
        longName
      }
    }
  }
`);
